import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

const tracks = [
  {
    title: 'System & Network Engineer (12 Weeks)',
    slug: 'system-network-engineer',
    desc: 'Master networking, cloud, security, troubleshooting, and pass CompTIA Network+ certification.',
    outcome: 'You will become: Job‑ready System & Network Engineer',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200&q=80&auto=format&fit=crop',
    logos: [
      'https://upload.wikimedia.org/wikipedia/commons/3/35/Tux.svg',
      'https://upload.wikimedia.org/wikipedia/commons/4/48/Windows_logo_-_2012.svg',
      'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg'
    ]
  },
  {
    title: 'Cloud & DevOps Engineer (12 Weeks)',
    slug: 'devops-engineer',
    desc: 'Learn Cloud, DevOps, CI/CD, Kubernetes, Terraform, Security & AIOps - Become Job Ready.',
    outcome: 'You will become: Job‑ready Cloud & DevOps Engineer',
    image: 'https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=1200&q=80&auto=format&fit=crop',
    logos: [
      'https://upload.wikimedia.org/wikipedia/commons/4/4e/Docker_%28container_engine%29_logo.svg',
      'https://upload.wikimedia.org/wikipedia/commons/3/39/Kubernetes_logo_without_workmark.svg',
      'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg'
    ]
  },
  {
    title: 'AI Engineer',
    slug: 'ai-engineer',
    desc: 'Master ML, GenAI, and cloud AI services. Build NLP/CV apps and deploy to production.',
    outcome: 'You will become: Job‑ready AI Engineer',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200&q=80&auto=format&fit=crop',
    logos: [
      'https://upload.wikimedia.org/wikipedia/commons/4/4d/OpenAI_Logo.svg',
      'https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg',
      'https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg'
    ]
  },
  {
    title: 'Cybersecurity Specialist',
    slug: 'cybersecurity-specialist',
    desc: 'Master security fundamentals, threat detection, incident response, and security tools to protect organizations.',
    outcome: 'You will become: Job‑ready Cybersecurity Specialist',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1200&q=80&auto=format&fit=crop',
    logos: [
      'https://upload.wikimedia.org/wikipedia/commons/4/4b/Bash_Logo_Colored.svg',
      'https://upload.wikimedia.org/wikipedia/commons/3/35/Tux.svg',
      'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg'
    ]
  }
];

const ProgramsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <Header />

      {/* Hero */}
      <section className="pt-20 pb-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">Choose Your Job‑Ready Path</h1>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">Role‑based, employer‑validated pathways with projects, mentorship and interview prep.</p>
        </div>
      </section>

      {/* Cards Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {tracks.map((t) => (
            <article key={t.slug} className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow flex flex-col">
              {/* Image */}
              <div className="relative h-36 sm:h-40 md:h-44 lg:h-40 xl:h-36 w-full overflow-hidden">
                <img src={t.image} alt={t.title} className="w-full h-full object-cover" />
                <span className="absolute top-3 left-3 bg-indigo-600 text-white text-xs font-semibold px-3 py-1 rounded-full">Job‑Ready Course</span>
                {t.logos && (
                  <div className="absolute bottom-2 right-2 flex items-center gap-2 bg-white/85 rounded-full px-2 py-1 shadow">
                    {t.logos.map((logo) => (
                      <img key={logo} src={logo} alt="logo" className="h-4 w-auto object-contain" />
                    ))}
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="flex-1 p-5 flex flex-col">
                <h3 className="text-lg font-bold text-slate-900 mb-2">{t.title}</h3>
                <p className="text-slate-600 text-sm mb-3 leading-relaxed">{t.desc}</p>
                <div className="mt-auto">
                  <div className="text-[13px] font-semibold text-indigo-700 mb-3">{t.outcome}</div>
                  <button className="cta-secondary w-full" onClick={() => navigate(`/programs/${t.slug}`)}>View Curriculum</button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProgramsPage;
